import React, { useLayoutEffect, useRef, useState } from 'react';
import { Map, Lightbulb } from 'lucide-react';

const TAB_ROADMAP = 'roadmap';
const TAB_SUESTOES = 'sugestoes';

const HubTabs = ({ activeTab, onTabChange }) => {
  const listRef = useRef(null);
  const roadmapRef = useRef(null);
  const sugestoesRef = useRef(null);
  const [indicatorStyle, setIndicatorStyle] = useState({ width: 0, transform: 'translateX(0)' });

  useLayoutEffect(() => {
    const updateIndicator = () => {
      const list = listRef.current;
      const activeEl = activeTab === TAB_ROADMAP ? roadmapRef.current : sugestoesRef.current;
      if (!list || !activeEl) return;
      setIndicatorStyle({
        width: activeEl.offsetWidth,
        transform: `translateX(${activeEl.offsetLeft}px)`,
      });
    };

    updateIndicator();
    window.addEventListener('resize', updateIndicator);
    return () => window.removeEventListener('resize', updateIndicator);
  }, [activeTab]);

  return (
    <div className="hub-feedback-tabs-list" ref={listRef} role="tablist" aria-label="Seções do hub">
      <span className="hub-feedback-tabs-indicator" style={indicatorStyle} aria-hidden="true" />
      <button
        type="button"
        ref={roadmapRef}
        role="tab"
        aria-selected={activeTab === TAB_ROADMAP}
        className={`hub-feedback-tabs-trigger${activeTab === TAB_ROADMAP ? ' is-active' : ''}`}
        onClick={() => onTabChange(TAB_ROADMAP)}
      >
        <Map size={13} strokeWidth={1.75} aria-hidden="true" />
        <span>Roadmap</span>
      </button>
      <button
        type="button"
        ref={sugestoesRef}
        role="tab"
        aria-selected={activeTab === TAB_SUESTOES}
        className={`hub-feedback-tabs-trigger${activeTab === TAB_SUESTOES ? ' is-active' : ''}`}
        onClick={() => onTabChange(TAB_SUESTOES)}
      >
        <Lightbulb size={13} strokeWidth={1.75} aria-hidden="true" />
        <span>Sugestões</span>
      </button>
    </div>
  );
};

export default HubTabs;
export { TAB_ROADMAP, TAB_SUESTOES };
